<template>
  <div>
<!--    -->
    <el-row :gutter="20" >
      <el-col :span="4">
        <el-input placeholder="兑换码" v-model="fetchParams.random"><el-button slot="append" icon="el-icon-search" @click="titleSearch"></el-button></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="手机号" v-model="fetchParams.mobile"><el-button slot="append" icon="el-icon-search" @click="titleSearch"></el-button></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="用户id" v-model="fetchParams.user_id"><el-button slot="append" icon="el-icon-search" @click="titleSearch"></el-button></el-input>
      </el-col>
      <el-col :span="4">
        <el-select v-model="fetchParams.is_use" @change="titleSearch" placeholder="商品类型"
                   style="width: 100%;">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <div >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-button-group>
            <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="show()">新增优惠券随机兑换码</el-button>
          </el-button-group>
        </el-col>
      </el-row>
      <el-table
        :data="dataList"
        style="width: 100%" >
        <el-table-column
          prop="id"
          label="id">
        </el-table-column>
        <el-table-column
          prop="random"
          label="兑换码">
        </el-table-column>
        <el-table-column
        prop="coupon"
        label="中台优惠券编码">
      </el-table-column>
        <el-table-column
          prop="user_id"
          label="用户id">
        </el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号">
        </el-table-column>
        <el-table-column
          label="是否可用"
          width="180">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.is_use == 1">已使用</el-tag>
            <el-tag type="success" v-if="scope.row.is_use == 2">已失效</el-tag>
            <el-tag v-else>未使用</el-tag>
          </template>
        </el-table-column>
      </el-table>

      <div class="content-padded content-center" v-if="pagers.total>0">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="fetchParams.page"
          :page-sizes="[10,20,50,100]"
          :total="pagers.total"
          :page-size="fetchParams.pageSize">
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { randomlist,buildrandom} from '@/api/member'

export default {

  data () {
    return {
      loading: false,
      dataList: [],
      pagers:{
        total: 0
      },
      options: [
        {value: 0, label: '未使用'},
        {value: 1,label: '已使用'}
      ],
      pageSize:20,
      currentPage:1,
      params: {},
      fetchParams: {
        page: 1,
        pageSize: 20,
        random:'',
        coupon:'',
        mobile:'',
        user_id:'',
        is_use:0,
      },
      number:100,
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    handleCurrentChange(val) {
      this.fetchParams.page = val
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.fetchParams.page = 1
      this.fetchParams.pageSize = pageSize
      this.getList()
    },
    titleSearch(){
      this.fetchParams.page = 1
      this.getList();
    },
    getList () {
      this.loading = true
      var params = {
        page_no: this.fetchParams.page,
        pageSize: this.fetchParams.pageSize,
        random:this.fetchParams.random,
        coupon:this.fetchParams.coupon,
        mobile:this.fetchParams.mobile,
        user_id:this.fetchParams.user_id,
        is_use:this.fetchParams.is_use,
      }
      randomlist(params).then(res => {
        if(res.data.data.list.length > 0) {
          this.dataList = res.data.data.list
          this.pagers.total = res.data.data.total_count
          this.loading = false
        } else {
          this.dataList = []
          this.loading = false
        }
      })
        .catch( error => {
          this.loading = false
        })
    },
    show(){
      this.$prompt('请输入优惠券数量和编码，用英文逗号，隔开', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // inputPattern: /^\d{3,}$/,
        // inputErrorMessage: '数量不能小于100'
      }).then(({ value }) => {
        this.$message({
          type: 'success',
          message: '提交的数据为: ' + value
        });
        this.number=value;
        this.add();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    add(){
      buildrandom({number:this.number}).then(res=>{
        if(res.data.data.status){
          this.$message({
            message: '生成成功！',
            type: 'success',
            duration: 2000
          })
        }else{
          this.$message({
            message: '失败了',
            type: 'error',
            duration: 2000
          })
        }
      })
    },

  },
  mounted () {
    this.getList()
  }
}

</script>
<style scoped lang="scss">
.el-icon-edit {
  cursor: pointer;
}
.coupon-list {
  margin-top: 10px;
}
.coupon-item {
  position: relative;
  height: 130px;
  padding: 25px 20px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dadadd;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  width: 19%;
  float: left;
  margin: .5%;
  &.coupon-add {
    padding-top: 20px;
    cursor: pointer;
    i {
      font-size: 40px;
    }
    :last-child { margin-top: 10px; }
  }
  .price {
    font-size: 24px;
  }
  .color-gray {
    color: #99A9BF;
  }
  .color-gray-deep {
    color: #8492A6;
  }
  .item-code {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  span.icon-triangle {
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-top: 34px solid #20a0ff;
    border-left: 34px solid transparent;
    color: #fff;
  }
  label {
    position: absolute;
    top: -34px;
    right: 0;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }
}
.item-bg {
  position: absolute;
  left: 0;
  bottom: -101%;
  width: 100%;
  height: 100%;
  background: rgba(241, 244, 246, .9);
  text-align: left;
  border-radius: 5px;
  padding-top: 8px;
  transition: all .4s ease;
  p {
    padding: 0 10px;
  }
  .item-operate {
    position: absolute;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .4);
    width: 100%;
    padding: 4px 0;
    text-align: center;
    cursor: pointer;
    a { color: #fff; }
  }
}
.coupon-item:hover {
  .item-bg {
    bottom: 0;
  }
}
.coupon-type-item {
  position: relative;
  padding: 30px 10px;
  border: 1px solid #ff5000;
  color: #ff5000;
  border-radius: 5px;
  text-align: center;
  margin-bottom: 20px;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
  &:first-child {
    font-size: 18px;
  }
  .coupon-type-desc {
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: -100%;
    left: 0;
    padding: 10px 0;
    background: #ff5000;
    color: #fff;
    font-size: 18px;
    transition: all .4s ease;
    div:last-child {
      width: 70%;
      margin: 8px auto 0;
      font-size: 12px;
    }
  }
  &:hover {
    .coupon-type-desc {
      bottom: 0;
    }
  }
}

.coupon-type-item, .sendout-item {
  overflow: hidden;
  .icon-checked {
    display: none;
    width: 100px;
    height: 25px;
    transform: rotate(35deg);
    position: absolute;
    font-size: 14;
    top: 5px;
    right: -25px;
    font-size: 20px;
    color: #fff;
    background: #ff5000;
    i {
      transform: rotate(-35deg);
    }
  }
  &.checked {
    .icon-checked {
      display: block;
    }
  }

  &:hover .icon-checked {
    background: #fff;
    i {
      color: #ff5000;
    }
  }
}
.store-pop {
  padding: 20px 15px;
  .store-content {
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// random.vue?91453b1c